module.exports = __webpack_public_path__ + "img/6.63c84943.png";